// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container{
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 20px;
  margin: 10px;
}
.container .card{
  position: relative;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  transition: .5s ease;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
  border-radius: 10px;
}
.container .card h2{
  cursor: pointer;
}
.darken-img {
  filter: brightness(50%);
}
.container .card:nth-child(1){
  background-color: rgb(224, 243, 255);
  padding: 10px;  
}
.container .card:nth-child(2){
  background-color: rgb(250, 205, 236);
  padding: 10px;
}
.container .card:nth-child(3){
  background-color: rgb(219, 250, 195);
  padding: 10px;
}
.container .card:nth-child(4){
  grid-column: 4 / 6;
  grid-row: 1/5;
}
.container .card:nth-child(5){
  grid-column: 6 / 6;
  grid-row: 1/5;
}
.container .card:nth-child(6){
  grid-column:  1/3;
  grid-row: 2/5;
}
.container .card:nth-child(7){
  grid-row: 2/5;
}
.container .card:nth-child(8){
grid-column:  1/3;
}
.container .card:nth-child(9){
  grid-column:  3/6;
  }
/* Responsive */
@media (max-width: 900px){
  .container{
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: 0.1fr 0.2fr 0.2fr 0.2fr 0.3fr 0.3fr 0.5fr 0.3fr 0.4fr 0.3fr 0.3fr 0.4fr 0.3fr 0.3fr;
  }
  .container .card{
      grid-row: unset !important;
      grid-column: unset !important;
  }
}
.dark-mode {
  background-color: #000;
  color: #e4d6d6;
}
.light-mode {
  color: #4b4848;
}
.high-contrast {
  background-color: #F5F5F5;
  color: #1A1A1A;
}
.responsive-input {
  width: 100%;
  padding: 0.5rem;
}
@media only screen and (max-width: 768px) {
  .responsive-input {
    padding: 0.3rem;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .responsive-input {
    padding: 0.4rem;
  }
}
@media only screen and (min-width: 1024px) {
  .responsive-input {
    padding: 0.5rem;
  }
}
.gm-style .gm-style-iw {
  border: none !important; /* Remove border */
  overflow: visible !important; /* Fixes clipping issues */
}
.gm-style-iw-d {
  overflow: hidden !important; /* Ensures no scrollbars appear */
  box-shadow: none !important; /* Remove any shadow if present */
}
.gm-ui-hover-effect {
  background-color: white !important; /* Change background to white */
  color: white !important; /* Change X color to black, if needed */
}
/* Change the SVG color inside the button */
.text-green-500 {
  color: green;
}
.text-blue-500 {
  color: blue;
}
.text-purple-500 {
  color: purple;
}
.text-red-500 {
  color: red;
}
.custom-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}


.installment-plan {
  padding: 20px;
}

.installment-plan form {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin: auto;
}

.installment-plan form div {
  margin-bottom: 15px;
}

.installment-plan form label {
  display: block;
  margin-bottom: 5px;
}

.installment-plan form input {
  width: 100%;
  padding: 8px;
}

.installment-plan form button {
  padding: 10px 15px;
}

.installment-plan ul {
  list-style-type: none;
  padding: 0;
}

.installment-plan li {
  margin-bottom: 10px;
}
/* Container that will have the custom scrollbar */
.overflow-y-auto {
  border-radius: 5px; 
  /* Add padding to prevent content from touching the scrollbar */
  padding-right: 10px; 
}

/* For Webkit browsers (Chrome, Safari, Edge) */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Make the scrollbar a bit wider for better visibility */
}

/* Style the thumb (the draggable part of the scrollbar) */
.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #bfbfc7; /* A nice, vibrant color from your gradient */
  border-radius: 20px;
  /* Add a subtle box-shadow for depth */
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

/* Style the track (the area the thumb moves along) */
.overflow-y-auto::-webkit-scrollbar-track {
  background-image: linear-gradient(to bottom, #35373a, #4c4c50 ,#8c8c91);
  border-radius: 20px;
}

/* Add a pseudo-class for a hover effect on the thumb */
.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background-color: #aaa9ba; /* Lighten the color on hover */
}
.spinner {
  border: 6px dashed rgba(28, 137, 226, 0.785);
  border-left-color: rgba(28, 137, 226, 0.785);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 5s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}


/* Spinner CSS */
.spinners {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #4f46e5; /* You can change the color */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spins 5s linear infinite;
}

@keyframes spins {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


.toogle:checked~.dot {
    transform: translateX(100%);
    /* background-color: #132b50; */
}
.tooltip {
  position: absolute; /* Make sure it’s positioned correctly */
  z-index: 9999; /* Ensures it appears above most elements */
  white-space: nowrap; /* Prevents long text from wrapping */
}

.group-hover:visible {
  display: block; /* In case visibility is an issue */
}


@media (max-width: 640px) {
  .date-filter-container {
    width: 100%;
    padding: 1rem;
  }
}

@media (min-width: 640px) {
  .date-filter-container {
    width: 300px;
  }
}

@media (min-width: 1024px) {
  .date-filter-container {
    width: 400px;
  }
}
.tooltips {
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  white-space: nowrap;
  z-index: 50;
}

.mapFilterSelect .mapFilterSelectRelative {
  margin-top: 0 !important;
}

.mapFilterSelect .mapFilterSelectRelative button {
  height: 44px;
  letter-spacing: 0.5px;
  width: 146px;
  /* background-color: #fefefebd; */
}

.mapFilterSelect .mapFilterSelectRelative ul,
.mapFilterSelect .mapFilterSelectRelative span {
  background-color: #fefefebd;
}

.mapFilterSelect .mapFilterSelectRelative button span,
.mapFilterSelect .mapFilterSelectRelative ul li span,
.mapFilterSelect .mapFilterSelectRelative ul li:hover span{
  background-color: transparent;
}

.map-activity .css-1nmdiq5-menu{
  margin-top: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-left: 1px;
  width: 217px;
  z-index: 111 !important;
}

.map-activity .css-1nmdiq5-menu .css-qr46ko{
  padding-inline: 7px;
}

.map-activity:has(.css-1nmdiq5-menu) .css-13cymwt-control,
.map-activity:has(.css-1nmdiq5-menu) .css-t3ipsp-control{
  border-bottom: #000000 !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.map-activity .css-13cymwt-control,
.map-activity .css-t3ipsp-control{
  border-radius: 8px;
}

.map-activity .css-t3ipsp-control:hover{
border-color: unset !important;
}

.map-activity .css-13cymwt-control .css-hlgwow .css-19bb58m input,
.map-activity .css-t3ipsp-control .css-hlgwow .css-1cfo1cf input{
  border:unset !important;
  outline: unset !important;
  outline-offset: unset !important;
}

.map-activity .css-13cymwt-control .css-1wy0on6 .css-1u9des2-indicatorSeparator,
.map-activity .css-t3ipsp-control .css-1wy0on6 .css-1u9des2-indicatorSeparator{
display: none;
}

.css-d7l1ni-option,
.css-10wo9uf-option:hover {
  background-color: #d7d6d666 !important;
}


.react-tel-input .flag-dropdown{
  border:0 !important;
  border-right:1px solid transparent !important;
}

.scrollbar-width-thin {
  scrollbar-width: thin;
}

.custom-side-scrollbar::-webkit-scrollbar-track
{
	border-radius: 10px;
	background-color: #EBF5FF !important;
}

.custom-side-scrollbar::-webkit-scrollbar
{
	width: 8px;
	background-color: #EBF5FF !important;
}

.custom-side-scrollbar::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	background-color: white;
}

.task-list-table {
  height: 79vh;
  min-height: 400px;
}

@media (max-height: 716px) {
 .task-list-table{
  height: 70vh;
 }
}
[type='text']:focus{
  box-shadow: none !important;
} 

  @media (max-width: 1213px) {
  .header {
   position: absolute;
  }
}

.account-history thead tr th, 
.account-history tbody tr td{
  border : 1px solid #e5e7eb;
}

.custom-draw {
  display: flex;
  gap:5px;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 1rem;
  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12); */
  overflow: hidden;
  margin-top: 80px;
  padding: 0.25rem;
  border : 1px solid #d7dfea;
}

.custom-zoom {
  display: flex;
  gap:5px;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 1rem;
  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12); */
  overflow: hidden;
  margin-top: 80px;
  margin-left: 12px;
  padding: 0.25rem;
  border : 1px solid #d7dfea;
}

/* Right-side map controls (zoom, map type, draw) - below list/map view buttons */
.leaflet-top.leaflet-right .custom-zoom,
.leaflet-top.leaflet-right .custom-draw {
  margin-top: 8px;
  margin-left: 0;
  margin-right: 12px;
}

.custom-btn {
  width: 40px;
  height: 40px;
  border: 1px solid #d7dfea;
  border-radius: 0.75rem;
  background: transparent;
  font-size: 22px;
  color:#0f1729;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-btn:hover,
.active{
  background: #f0f6fe;
  border-color: #5286f7;
  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);
}

.custom-zoom-level {
  font-size: 12px;
  font-weight: 600;
  color: #65708b;
  padding: 0.25rem 0;
  -webkit-user-select: none;
          user-select: none;
}

.custom-btn[data-tooltip] {
  position: relative;
  cursor: pointer;
}

.custom-btn[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);
  background: #FFF;
  color: #222;
  border: 1px solid #d7dfea;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 1000;
}

.custom-btn[data-tooltip]:hover::after {
  opacity: 1;
}

/* Tracking line start/end point markers on map */
.tracking-point-marker {
  background: transparent !important;
  border: none !important;
}
.tracking-point-marker .tracking-point-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.35);
}
.tracking-point-marker.tracking-start .tracking-point-label {
  background: #16a34a;
}
.tracking-point-marker.tracking-end .tracking-point-label {
  background: #dc2626;
}
/* Visible scrollbar for react-select dropdown menu (e.g. Next step success/failure) */
.select__menu-list {
  overflow-y: auto !important;
  scrollbar-width: thin;
}
.select__menu-list::-webkit-scrollbar {
  width: 8px;
}
.select__menu-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.select__menu-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.select__menu-list::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Multi-select chips area: flex min-height + visible scrollbar (MultipleActivitySelect) */
.multiple-activity-select-scroll .select__value-container {
  overflow-y: auto !important;
  scrollbar-width: thin;
}
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar {
  width: 8px;
}
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.bottom-toolbar-container {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-radius: 14px;
}

.bottom-toolbar-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid #d7dfea;
  background: #e1e7ef;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.bottom-toolbar-btn:hover{
  border-color: #5286f7;
  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);
}
.bottom-toolbar-btn:hover .active {
 color: #5286f7;
  border-color: #5286f7;
  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);
}

.bottom-toolbar-btn svg {
  font-size: 18px;
  color: #374151;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;AACA,iBAAiB;AACjB;AACA;EACE,iBAAiB;EACjB;AACF,eAAe;AACf;EACE;MACI,qCAAqC;MACrC,uGAAuG;EAC3G;EACA;MACI,0BAA0B;MAC1B,6BAA6B;EACjC;AACF;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EAKE,WAAW;EACX,eAAe;AAHjB;AAKA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,uBAAuB,EAAE,kBAAkB;EAC3C,4BAA4B,EAAE,0BAA0B;AAC1D;AACA;EACE,2BAA2B,EAAE,iCAAiC;EAC9D,2BAA2B,EAAE,iCAAiC;AAChE;AACA;EACE,kCAAkC,EAAE,+BAA+B;EACnE,uBAAuB,EAAE,uCAAuC;AAClE;AACA,2CAA2C;AAC3C;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;AACA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,UAAU,EAAE,yDAAyD;AACvE;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB,EAAE,6CAA6C;EACxE,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA,qDAAqD;AACrD;EACE,uEAAuE;EACvE,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;AACA;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;;AAGA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,0BAA0B,EAAE,6BAA6B;EACzD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;AACA;EACE,kBAAkB,EAAE,wCAAwC;EAC5D,aAAa,EAAE,2CAA2C;EAC1D,mBAAmB,EAAE,qCAAqC;AAC5D;;AAEA;EACE,cAAc,EAAE,mCAAmC;AACrD;;;AAGA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;AACA,8BAA8B;AAC9B;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;AAEA,aAAa;AACb;;AAEA;;EAEE,sCAAsC;AACxC;;;AAGA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;CAEC,mBAAmB;CACnB,oCAAoC;AACrC;;AAEA;;CAEC,UAAU;CACV,oCAAoC;AACrC;;AAEA;;CAEC,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;CACC;EACC,YAAY;CACb;AACD;AACA;EACE,2BAA2B;AAC7B;;EAEE;EACA;GACC,kBAAkB;EACnB;AACF;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iFAAiF;AACjF;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,sFAAsF;AACtF;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,0FAA0F;AAC1F;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;AACA;CACC,cAAc;EACb,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@100..900&display=swap');\n\n.container{\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n  gap: 20px;\n  margin: 10px;\n}\n.container .card{\n  position: relative;\n  background: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  transition: .5s ease;\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\n  border-radius: 10px;\n}\n.container .card h2{\n  cursor: pointer;\n}\n.darken-img {\n  filter: brightness(50%);\n}\n.container .card:nth-child(1){\n  background-color: rgb(224, 243, 255);\n  padding: 10px;  \n}\n.container .card:nth-child(2){\n  background-color: rgb(250, 205, 236);\n  padding: 10px;\n}\n.container .card:nth-child(3){\n  background-color: rgb(219, 250, 195);\n  padding: 10px;\n}\n.container .card:nth-child(4){\n  grid-column: 4 / 6;\n  grid-row: 1/5;\n}\n.container .card:nth-child(5){\n  grid-column: 6 / 6;\n  grid-row: 1/5;\n}\n.container .card:nth-child(6){\n  grid-column:  1/3;\n  grid-row: 2/5;\n}\n.container .card:nth-child(7){\n  grid-row: 2/5;\n}\n.container .card:nth-child(8){\ngrid-column:  1/3;\n}\n.container .card:nth-child(9){\n  grid-column:  3/6;\n  }\n/* Responsive */\n@media (max-width: 900px){\n  .container{\n      grid-template-columns: repeat(1, 1fr);\n      grid-template-rows: 0.1fr 0.2fr 0.2fr 0.2fr 0.3fr 0.3fr 0.5fr 0.3fr 0.4fr 0.3fr 0.3fr 0.4fr 0.3fr 0.3fr;\n  }\n  .container .card{\n      grid-row: unset !important;\n      grid-column: unset !important;\n  }\n}\n.dark-mode {\n  background-color: #000;\n  color: #e4d6d6;\n}\n.light-mode {\n  color: #4b4848;\n}\n.high-contrast {\n  background-color: #F5F5F5;\n  color: #1A1A1A;\n}\n.responsive-input {\n  width: 100%;\n  padding: 0.5rem;\n}\n.responsive-input {\n  width: 100%;\n  padding: 0.5rem; \n}\n@media only screen and (max-width: 768px) {\n  .responsive-input {\n    padding: 0.3rem;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .responsive-input {\n    padding: 0.4rem;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .responsive-input {\n    padding: 0.5rem;\n  }\n}\n.gm-style .gm-style-iw {\n  border: none !important; /* Remove border */\n  overflow: visible !important; /* Fixes clipping issues */\n}\n.gm-style-iw-d {\n  overflow: hidden !important; /* Ensures no scrollbars appear */\n  box-shadow: none !important; /* Remove any shadow if present */\n}\n.gm-ui-hover-effect {\n  background-color: white !important; /* Change background to white */\n  color: white !important; /* Change X color to black, if needed */\n}\n/* Change the SVG color inside the button */\n.text-green-500 {\n  color: green;\n}\n.text-blue-500 {\n  color: blue;\n}\n.text-purple-500 {\n  color: purple;\n}\n.text-red-500 {\n  color: red;\n}\n.custom-scrollbar {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n\n.installment-plan {\n  padding: 20px;\n}\n\n.installment-plan form {\n  display: flex;\n  flex-direction: column;\n  max-width: 400px;\n  margin: auto;\n}\n\n.installment-plan form div {\n  margin-bottom: 15px;\n}\n\n.installment-plan form label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.installment-plan form input {\n  width: 100%;\n  padding: 8px;\n}\n\n.installment-plan form button {\n  padding: 10px 15px;\n}\n\n.installment-plan ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.installment-plan li {\n  margin-bottom: 10px;\n}\n/* Container that will have the custom scrollbar */\n.overflow-y-auto {\n  border-radius: 5px; \n  /* Add padding to prevent content from touching the scrollbar */\n  padding-right: 10px; \n}\n\n/* For Webkit browsers (Chrome, Safari, Edge) */\n.overflow-y-auto::-webkit-scrollbar {\n  width: 8px; /* Make the scrollbar a bit wider for better visibility */\n}\n\n/* Style the thumb (the draggable part of the scrollbar) */\n.overflow-y-auto::-webkit-scrollbar-thumb {\n  background-color: #bfbfc7; /* A nice, vibrant color from your gradient */\n  border-radius: 20px;\n  /* Add a subtle box-shadow for depth */\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n/* Style the track (the area the thumb moves along) */\n.overflow-y-auto::-webkit-scrollbar-track {\n  background-image: linear-gradient(to bottom, #35373a, #4c4c50 ,#8c8c91);\n  border-radius: 20px;\n}\n\n/* Add a pseudo-class for a hover effect on the thumb */\n.overflow-y-auto::-webkit-scrollbar-thumb:hover {\n  background-color: #aaa9ba; /* Lighten the color on hover */\n}\n.spinner {\n  border: 6px dashed rgba(28, 137, 226, 0.785);\n  border-left-color: rgba(28, 137, 226, 0.785);\n  border-radius: 50%;\n  width: 80px;\n  height: 80px;\n  animation: spin 5s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/* Spinner CSS */\n.spinners {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #4f46e5; /* You can change the color */\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spins 5s linear infinite;\n}\n\n@keyframes spins {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n.toogle:checked~.dot {\n    transform: translateX(100%);\n    /* background-color: #132b50; */\n}\n.tooltip {\n  position: absolute; /* Make sure it’s positioned correctly */\n  z-index: 9999; /* Ensures it appears above most elements */\n  white-space: nowrap; /* Prevents long text from wrapping */\n}\n\n.group-hover:visible {\n  display: block; /* In case visibility is an issue */\n}\n\n\n@media (max-width: 640px) {\n  .date-filter-container {\n    width: 100%;\n    padding: 1rem;\n  }\n}\n\n@media (min-width: 640px) {\n  .date-filter-container {\n    width: 300px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .date-filter-container {\n    width: 400px;\n  }\n}\n.tooltips {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  white-space: nowrap;\n  z-index: 50;\n}\n\n.mapFilterSelect .mapFilterSelectRelative {\n  margin-top: 0 !important;\n}\n\n.mapFilterSelect .mapFilterSelectRelative button {\n  height: 44px;\n  letter-spacing: 0.5px;\n  width: 146px;\n  /* background-color: #fefefebd; */\n}\n\n.mapFilterSelect .mapFilterSelectRelative ul,\n.mapFilterSelect .mapFilterSelectRelative span {\n  background-color: #fefefebd;\n}\n\n.mapFilterSelect .mapFilterSelectRelative button span,\n.mapFilterSelect .mapFilterSelectRelative ul li span,\n.mapFilterSelect .mapFilterSelectRelative ul li:hover span{\n  background-color: transparent;\n}\n\n.map-activity .css-1nmdiq5-menu{\n  margin-top: 0px;\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  margin-left: 1px;\n  width: 217px;\n  z-index: 111 !important;\n}\n\n.map-activity .css-1nmdiq5-menu .css-qr46ko{\n  padding-inline: 7px;\n}\n\n.map-activity:has(.css-1nmdiq5-menu) .css-13cymwt-control,\n.map-activity:has(.css-1nmdiq5-menu) .css-t3ipsp-control{\n  border-bottom: #000000 !important;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n\n.map-activity .css-13cymwt-control,\n.map-activity .css-t3ipsp-control{\n  border-radius: 8px;\n}\n\n.map-activity .css-t3ipsp-control:hover{\nborder-color: unset !important;\n}\n\n.map-activity .css-13cymwt-control .css-hlgwow .css-19bb58m input,\n.map-activity .css-t3ipsp-control .css-hlgwow .css-1cfo1cf input{\n  border:unset !important;\n  outline: unset !important;\n  outline-offset: unset !important;\n}\n\n.map-activity .css-13cymwt-control .css-1wy0on6 .css-1u9des2-indicatorSeparator,\n.map-activity .css-t3ipsp-control .css-1wy0on6 .css-1u9des2-indicatorSeparator{\ndisplay: none;\n}\n\n.css-d7l1ni-option,\n.css-10wo9uf-option:hover {\n  background-color: #d7d6d666 !important;\n}\n\n\n.react-tel-input .flag-dropdown{\n  border:0 !important;\n  border-right:1px solid transparent !important;\n}\n\n.scrollbar-width-thin {\n  scrollbar-width: thin;\n}\n\n.custom-side-scrollbar::-webkit-scrollbar-track\n{\n\tborder-radius: 10px;\n\tbackground-color: #EBF5FF !important;\n}\n\n.custom-side-scrollbar::-webkit-scrollbar\n{\n\twidth: 8px;\n\tbackground-color: #EBF5FF !important;\n}\n\n.custom-side-scrollbar::-webkit-scrollbar-thumb\n{\n\tborder-radius: 10px;\n\tbackground-color: white;\n}\n\n.task-list-table {\n  height: 79vh;\n  min-height: 400px;\n}\n\n@media (max-height: 716px) {\n .task-list-table{\n  height: 70vh;\n }\n}\n[type='text']:focus{\n  box-shadow: none !important;\n} \n\n  @media (max-width: 1213px) {\n  .header {\n   position: absolute;\n  }\n}\n\n.account-history thead tr th, \n.account-history tbody tr td{\n  border : 1px solid #e5e7eb;\n}\n\n.custom-draw {\n  display: flex;\n  gap:5px;\n  flex-direction: column;\n  align-items: center;\n  background: #ffffff;\n  border-radius: 1rem;\n  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12); */\n  overflow: hidden;\n  margin-top: 80px;\n  padding: 0.25rem;\n  border : 1px solid #d7dfea;\n}\n\n.custom-zoom {\n  display: flex;\n  gap:5px;\n  flex-direction: column;\n  align-items: center;\n  background: #ffffff;\n  border-radius: 1rem;\n  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12); */\n  overflow: hidden;\n  margin-top: 80px;\n  margin-left: 12px;\n  padding: 0.25rem;\n  border : 1px solid #d7dfea;\n}\n\n/* Right-side map controls (zoom, map type, draw) - below list/map view buttons */\n.leaflet-top.leaflet-right .custom-zoom,\n.leaflet-top.leaflet-right .custom-draw {\n  margin-top: 8px;\n  margin-left: 0;\n  margin-right: 12px;\n}\n\n.custom-btn {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #d7dfea;\n  border-radius: 0.75rem;\n  background: transparent;\n  font-size: 22px;\n  color:#0f1729;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.custom-btn:hover,\n.active{\n  background: #f0f6fe;\n  border-color: #5286f7;\n  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);\n}\n\n.custom-zoom-level {\n  font-size: 12px;\n  font-weight: 600;\n  color: #65708b;\n  padding: 0.25rem 0;\n  user-select: none;\n}\n\n.custom-btn[data-tooltip] {\n  position: relative;\n  cursor: pointer;\n}\n\n.custom-btn[data-tooltip]::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  top: -32px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #FFF;\n  color: #222;\n  border: 1px solid #d7dfea;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s;\n  z-index: 1000;\n}\n\n.custom-btn[data-tooltip]:hover::after {\n  opacity: 1;\n}\n\n/* Tracking line start/end point markers on map */\n.tracking-point-marker {\n  background: transparent !important;\n  border: none !important;\n}\n.tracking-point-marker .tracking-point-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 700;\n  color: #fff;\n  border: 2px solid #fff;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.35);\n}\n.tracking-point-marker.tracking-start .tracking-point-label {\n  background: #16a34a;\n}\n.tracking-point-marker.tracking-end .tracking-point-label {\n  background: #dc2626;\n}\n/* Visible scrollbar for react-select dropdown menu (e.g. Next step success/failure) */\n.select__menu-list {\n  overflow-y: auto !important;\n  scrollbar-width: thin;\n}\n.select__menu-list::-webkit-scrollbar {\n  width: 8px;\n}\n.select__menu-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n.select__menu-list::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n.select__menu-list::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n\n/* Multi-select chips area: flex min-height + visible scrollbar (MultipleActivitySelect) */\n.multiple-activity-select-scroll .select__value-container {\n  overflow-y: auto !important;\n  scrollbar-width: thin;\n}\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar {\n  width: 8px;\n}\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n\n.bottom-toolbar-container {\n  display: flex;\n  gap: 8px;\n  padding: 8px;\n  border-radius: 14px;\n}\n\n.bottom-toolbar-btn {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  border: 1px solid #d7dfea;\n  background: #e1e7ef;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.bottom-toolbar-btn:hover{\n  border-color: #5286f7;\n  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);\n}\n.bottom-toolbar-btn:hover .active {\n color: #5286f7;\n  border-color: #5286f7;\n  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);\n}\n\n.bottom-toolbar-btn svg {\n  font-size: 18px;\n  color: #374151;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
